import { useQuery } from '@tanstack/react-query';
import { getTransmitters, getAllAccountNames } from '../api';
import type { TransmittersFilters } from '../types';

// =============================================================================
// Query Keys Factory
// =============================================================================

export const transmittersKeys = {
  all: ['transmitters'] as const,
  list: (filters?: TransmittersFilters) =>
    [...transmittersKeys.all, 'list', filters] as const,
  populate: (id: string, isAdmin: boolean) =>
    [...transmittersKeys.all, 'populate', id, isAdmin] as const,
  options: (orgId?: string) => [...transmittersKeys.all, 'options', orgId] as const,
  changelog: (id: string) => [...transmittersKeys.all, 'changelog', id] as const,
};


// =============================================================================
// Query Hooks
// =============================================================================

/**
 * Hook to fetch transmitters list with filtering and pagination
 */
export function useTransmitters(filters: TransmittersFilters = {}) {
  return useQuery({
    queryKey: transmittersKeys.list(filters),
    queryFn: () => getTransmitters(filters),
    staleTime: 30 * 1000,
  });
}

/**
 * Hook to fetch all account names for searchable dropdown filters
 */
export function useAllAccounts() {
  return useQuery({
    queryKey: [...transmittersKeys.all, 'accounts'],
    queryFn: getAllAccountNames,
    staleTime: 5 * 60 * 1000,
  });
}

